<template>
  <div class="messages auto-campaign-message-show">
    <div v-if="message" class="message-container" :data-message-id="message.id">
      <div class="data-title">{{messageTitle}}</div>

      <content-section :campaignItem="details"
                       :isTracked="isTracked"
                       :isReferral="isReferral"
                       isMessage></content-section>

      <div class="row">
        <div class="large-12 columns message-show-stats-extension">
          <div class="m-6">
            <div class="text-center">
              tracking duration post customer reception of campaign
            </div>
            <div class="duration-container flex flex-row content-center justify-center">
              <template v-for="duration in trackingDurationList">
                <input
                  v-model="trackingDuration"
                  class="tracking-duration-radio"
                  type="radio"
                  :value="duration"
                  :name="`message-${message.id}-duration-${duration}`"
                  :id="`message-${message.id}-duration-${duration}`"/>
                <label
                  class="tracking-duration-container"
                  :key="`message-${message.id}-radio-${duration}`"
                  :for="`message-${message.id}-duration-${duration}`">
                  {{ duration }}
                </label>
              </template>
            </div>
          </div>
          <stats-widget :attachedMedia="hasAttachedMediaDisplay"
                        :extensionName="extensionName"
                        :isTracked="isTracked"
                        :rewardType="rewardType"
                        isAutoconnect
                        :has-notification-image="hasNotificationImage"
                        titleClasses="sub-title text-center"
                        hide-export-action
                        :key="`stats-widget-${trackingDuration}-${message.id}`"
                        :trackingDuration.sync="trackingDuration"
                        :url="statsUrl"></stats-widget>

          <extension-details v-if="extension && extension.name !== '--'"
                             :extension="extension"
                             :extensionType="extensionType"
                             :isOffer="isOffer"
                             :rewardId="rewardId"
                             @updateRewardType="updateRewardType"></extension-details>
        </div>
      </div>
    </div>
    <div class="divider"></div>
  </div>
</template>

<script>
  import AxiosMixin from '../../mixins/AxiosMixin'
  import CommunicationShowMixin from '../../mixins/CommunicationShowMixin'
  import ContentSection from '../CommunicationItems/ContentSection'
  import ExtensionDetails from '../CommunicationItems/ExtensionDetails'
  import { isObject } from '../../utilities/index'
  import LoadErrorMixin from '../../mixins/LoadErrorMixin'
  import StatsWidget from '../CommunicationItems/StatsWidget'
  import {mapGetters} from "vuex"
  import {trackingDurationList} from "../../config/tracking";

  export default {
    props: {
      attachmentsUrl: String,
      isReferral: Boolean,
      message: Object,
      messageCountIndex: [Number, String],
      scope: Object,
      statsUrl: String
    },

    name: 'MessageShow',

    components: {
      ContentSection,
      ExtensionDetails,
      StatsWidget,
    },

    mixins: [AxiosMixin, CommunicationShowMixin, LoadErrorMixin],

    data() {
      return {
        audio: null,
        errorText: 'we encountered an issue loading the attached media.',
        extensionOwnerType: 'AutoCampaignMessage',
        mediaTypes: ['mms', 'audio'],
        messageDetails: null,
        mms: null,
        trackingDuration: '2d',
        trackingDurationList,
        stashboardMedia: []
      }
    },

    methods: {
      configureAttachedMedia(data) {
        this.stashboardMedia = data
        this.errorMessage = hasData ? null : this.errorText
      },

      createDetails() {
        return {
          audio: this.audio?.map(audio => audio.url),
          extension_type: this.message._type,
          any_links: this.message.any_links,
          id: this.message.id,
          stashboard_media: this.stashboardMedia,
          image_type: this.message.image_type,
          mock_url: this.message.mock_url,
          reward_id: this.message.reward_id,
          send_at: this.message.send_at,
          sms_content: this.message.sms_content,
          wallet_target: this.message._type_options,
          template_content: this.message.template_content,
          referral_template_content: this.message.referral_template_content,
          template_image: this.scope.template_image
        }
      },

       getAttachedMedia() {
        const params = { params: { label: this.mediaTypes } }
         !!this.attachmentsUrl && this.axiosMethod({
          url: this.attachmentsUrl,
          params,
          onSuccess: this.configureAttachedMedia,
          onError: this.setLoadError
        })
      },

      setDetailsItems() {
        this.communicationDetails = this.details
        this.rewardId = this.details?.reward_id
        this.extensionType = this.details?.extension_type
        this.isTracked = true; //[1, 2, 3, 4, 5, 6].includes(this.extensionType)
        this.extension = this.configureExtension()
      },

      setMessageData(data) {
        if (data && isObject(data)) {
          this.messageDetails = data
          this.errorMessage = null
        } else {
          this.errorMessage = this.errorText
        }
      },
    },

    created() {
      this.getAttachedMedia()
    },

    computed: {
      details: function () {
        return this.message ? this.createDetails() : null
      },

      extensionName: function() {
        return this.extension ? this.extension.name : ''
      },

      hasAttachedMediaDisplay: function () {
        const hasMedia = this.audio?.length || this.mms?.length,
          media = hasMedia && hasMedia > 0 ? 'yes' : 'no'
        return { label: 'audio/mms', media }
      },

      hasNotificationImage(){
        if(this.hasNotificationMmsMetaEnabled) {
          return this.scope?.template_image ? "yes" : "no"
        }
        return null
      },

      messageTitle: function () {
        return this.isReferral ? 'customer joining via referral will receive:' : 'campaign content'
      },

      ...mapGetters(['hasNotificationMmsMetaEnabled'])
    },

    watch: {
      message: {
        immediate: true,
        handler() {
          this.setDetailsItems()
        }
      }
    }
  }
</script>
